<template>
  <div class="main_wrap">
    <header>
      <Navigator :routeList="navigate" />
    </header>
    <main>
      <div class="class-item">
        <!-- 学校信息 -->
        <div class="school-header">
          <span class="school-title">
            <el-image
              class="school-cover"
              :src="require('@/assets/icons/icon_school.png')"
            ></el-image>
            {{ schoolName }}&nbsp; / &nbsp;{{ className }}
          </span>
          <div class="tool-bar">
            <div class="add">
              <el-button
                type="primary"
                icon="el-icon-circle-plus-outline"
                @click="jumpToSubjectDetail"
              >
                班级学情报告
              </el-button>
            </div>
          </div>
        </div>
        <div class="condition-report">
          <iframe
            ref="iframe"
            :src="`${iframeUrl}/errorList?source=AFTER_CLASS&clazzId=${classId}&token=${token}&clientType=pc`"
            :onerror="loadError"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Navigator from "@/components/navigate.vue";
import { iframeUrl } from "@/config/env";

export default {
  name: "studyConditionRecord",
  components: { Navigator },
  data: function () {
    return {
      navigate: [
        { name: "我的课后班", url: "/mine/myAfterclass" },
        { name: "班级学情", isCurrent: true },
      ],
      schoolName: "",
      className: "",
      classId: "",
      token: "",
      iframeUrl: "",
      chooseActive: false,
      courseId: "",
      teachingAuxiliaryId: "",
    };
  },
  methods: {
    loadError() {
      alert("加载失败");
    },
    loadData() {
      this.iframeUrl = iframeUrl;
      const query = this.$route.query;
      this.schoolName = decodeURIComponent(query.schoolName);
      this.className = decodeURIComponent(query.className);
      this.classId = query.classId;
      this.token = localStorage.userToken;
      this.courseId = query.courseId;
      this.teachingAuxiliaryId = query.teachingAuxiliaryId;
    },
    changeActive() {
      this.chooseActive = !this.chooseActive;
    },
    //新建班级学情
    jumpToSubjectDetail() {
      this.$router.push(
        `/course/subjectDetail/${this.courseId}?teachingAuxiliaryId=${this.teachingAuxiliaryId}&from=1&target=resourse`
      );
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style lang="scss" scoped>
.main_wrap {
  width: 100%;
  height: 100%;

  header {
    margin-bottom: 5rem;
  }

  main {
    .class-item {
      margin-bottom: 5rem;
      .school-header {
        margin-bottom: 3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-weight: 600;
        .school-title {
          color: #333333;
          font-size: 1.8rem;
          display: flex;
          align-items: center;
          .school-cover {
            height: 2.4rem;
            width: 2.4rem;
            margin-right: 1rem;
          }
        }

        .tool-bar {
          display: flex;
          // margin-right: 2rem;

          ::v-deep .el-button {
            font-size: 1.8rem;
            border-radius: 1rem;
            background: $color-primary;
            border: 0.1rem $color-primary solid;
            padding: 1.2rem 2rem;
          }
          // .add {
          //   padding-right: 2rem;
          //   margin-right: 2rem;
          //   border-right: 0.1rem solid rgba(126, 126, 126, 0.2);
          // }
          // .choose {
          //   ::v-deep .el-button {
          //     background: #ffffff;
          //     color: #09a7ff;
          //     &:hover {
          //       background: #00a2e9;
          //       color: #ffffff;
          //     }
          //     &:focus {
          //       background: #00a2e9;
          //       color: #ffffff;
          //     }
          //   }
          //   ::v-deep .active {
          //     background: #00a2e9;
          //     color: #ffffff;
          //   }
          // }
        }
      }

      .condition-report {
        border-radius: 0.4rem;
        width: 100%;
        height: calc(100vh - 24rem);

        iframe {
          height: 100%;
          width: 100%;
        }
      }
    }
  }
}
</style>